export function safeArray(value) {
  return Array.isArray(value) ? value : [];
}

export function safeObject(value) {
  return value && typeof value === "object" && !Array.isArray(value) ? value : {};
}

export function isActiveUser(profile) {
  return Boolean(profile?.isActive);
}

export function hasRole(profile, role) {
  return safeArray(profile?.roles).includes(role);
}

export function hasAnyRole(profile, roles = []) {
  const userRoles = safeArray(profile?.roles);
  return roles.some((r) => userRoles.includes(r));
}

export function hasPermission(profile, permission) {
  const permissions = safeObject(profile?.permissions);
  return Boolean(permissions[permission]);
}

export function isAdmin(profile) {
  return hasRole(profile, "admin");
}

export function isInspector(profile) {
  return hasRole(profile, "inspector");
}

export function isPartnerInspector(profile) {
  return hasRole(profile, "partner_inspector");
}

export function canReviewInspection(profile) {
  return isActiveUser(profile) && hasPermission(profile, "inspectionReview");
}

export function canManagePickup(profile) {
  return isActiveUser(profile) && hasPermission(profile, "pickupManagement");
}

export function canManageDelivery(profile) {
  return isActiveUser(profile) && hasPermission(profile, "deliveryManagement");
}

export function canApproveSellerPrep(profile) {
  return isActiveUser(profile) && hasPermission(profile, "sellerPrepApproval");
}

export function canManageTradeIssues(profile) {
  return isActiveUser(profile) && hasPermission(profile, "tradeIssueManagement");
}

export function canManageRoles(profile) {
  return isActiveUser(profile) && hasPermission(profile, "roleManagement");
}

export function isOperationalStaff(profile) {
  if (!isActiveUser(profile)) return false;

  // Check roles
  if (hasRole(profile, "inspector") || hasRole(profile, "partner_inspector")) {
    return true;
  }

  // Check operational permissions
  if (
    hasPermission(profile, "inspectionReview") ||
    hasPermission(profile, "pickupManagement") ||
    hasPermission(profile, "deliveryManagement")
  ) {
    return true;
  }

  return false;
}

export function isTradingRestricted(profile) {
  // Explicit restriction
  if (profile?.tradingRestricted === true) {
    return true;
  }

  // Operational staff without admin override
  if (isOperationalStaff(profile) && !isAdmin(profile)) {
    return true;
  }

  return false;
}